export default __webpack_public_path__ + "static/media/bookstack.0ac056b9.svg";